/**
 * @generated SignedSource<<8e20fca27363b392a6a4cb25c49bb07c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type MeetingRecordingProvider = "CLIENT_SIDE" | "CONIFER" | "CONIFER_ZOOM_RTMS" | "FELLOW_PREMADE" | "RECALLAI" | "THIRD_PARTY" | "UPLOAD";
export type MeetingRecordingStatus = "CALL_ENDED" | "ERROR" | "IN_WAITING_ROOM" | "JOINED_CALL" | "JOIN_REQUEST_DENIED" | "KICKED_OUT" | "LEFT_DUE_TO_INACTIVITY" | "PAUSED" | "READY" | "RECORDING" | "RECORDING_DONE" | "RECORDING_PERMISSION_DENIED" | "SCHEDULED" | "TIME_OUT_EXCEEDED_IN_CALL_NOT_RECORDING" | "TIME_OUT_EXCEEDED_RECORDING_PERMISSION_DENIED" | "TIME_OUT_EXCEEDED_WAITING_ROOM" | "TRANSCRIPTION_DONE" | "UNKNOWN" | "UNRECOVERABLE" | "ZOOM_BOT_IN_WAITING_ROOM" | "ZOOM_HOST_NOT_PRESENT" | "ZOOM_LOCAL_RECORDING_DISABLED" | "ZOOM_LOCAL_RECORDING_GRANT_NOT_SUPPORTED" | "ZOOM_LOCAL_RECORDING_REQUEST_DENIED_BY_HOST" | "ZOOM_LOCAL_RECORDING_REQUEST_DISABLED" | "ZOOM_LOCAL_RECORDING_REQUEST_DISABLED_BY_HOST";
export type NoteRecordingErrorType = "CANCELLED" | "GENERIC";
export type RecordingMediaType = "AUDIO" | "VIDEO";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
import { FragmentRefs } from "relay-runtime";
export type MeetingPhaseContext_note$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
  };
  readonly event: {
    readonly conferenceCalls: ReadonlyArray<{
      readonly provider: ConferenceCallProvider;
      readonly url: string;
    }>;
    readonly end: string | null;
    readonly hasUsersWithExternalEmail: boolean;
    readonly id: string;
    readonly isAllDay: boolean;
    readonly start: string | null;
    readonly status: StatusChoices;
    readonly title: string;
  } | null;
  readonly eventGuid: string | null;
  readonly finished: boolean;
  readonly groupName: string;
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly externalRecordingProvider: MeetingRecordingProvider;
    readonly id: string;
    readonly mediaType: RecordingMediaType;
    readonly meetingCallStart: string;
    readonly status: MeetingRecordingStatus;
    readonly userWhoStartedRecording: {
      readonly firstName: string;
      readonly id: string;
    } | null;
  }> | null;
  readonly recordingErrorIndicator: {
    readonly cancelledBy: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
    } | null;
    readonly errorType: NoteRecordingErrorType;
    readonly message: string | null;
    readonly updatedAt: string;
  } | null;
  readonly stream: {
    readonly id: string;
    readonly schedulingMeetingAssistantAutomationIsActive: boolean;
  };
  readonly url: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"AutoSendToEveryone_autoShareIsSetToEveryone_note" | "utils_useAutoRefetchMeetingRecording_note">;
  readonly " $fragmentType": "MeetingPhaseContext_note";
};
export type MeetingPhaseContext_note$key = {
  readonly " $data"?: MeetingPhaseContext_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingPhaseContext_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingPhaseContext_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAllDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConferenceCall",
          "kind": "LinkedField",
          "name": "conferenceCalls",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "provider",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUsersWithExternalEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventGuid",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "schedulingMeetingAssistantAutomationIsActive",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalRecordingProvider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mediaType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "userWhoStartedRecording",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecordingErrorIndicator",
      "kind": "LinkedField",
      "name": "recordingErrorIndicator",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "cancelledBy",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useAutoRefetchMeetingRecording_note"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AutoSendToEveryone_autoShareIsSetToEveryone_note",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStream",
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "meetingRecapAutoShareSource",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_S",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "StreamMeetingRecapAutoShareSettings",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_U",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "UserMeetingRecapAutoShareSettings",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "2ac7de80f1b5ba30086913674e91d238";

export default node;
